import { Box } from '@src/atoms/Box';
import { Button } from '@src/atoms/Button';
import { Text } from '@src/atoms/Text';
import React, { FC, useCallback } from 'react';

import styles from './FiltersIconButton.scss';

interface IFilterButtonMobile {
  count: number;
  onOpen: (v: boolean) => void;
}

/** Компонент `иконка` для отображения кол-ва фильтров и функцией их включения. Подразумевается для мобильного использования */
export const FiltersIconButton: FC<IFilterButtonMobile> = ({ count, onOpen }) => {
  const handleClick = useCallback(() => {
    onOpen(true);
  }, [onOpen]);

  return (
    <Box className={styles.container}>
      <Button id="filterIcon" preIcon={'filter'} view={'secondaryLight'} fullWidth onClick={handleClick} />
      {!!count && (
        <Box className={styles.counter} paddingTop={2} bgColor={'statusError'} justifyContent={'center'}>
          <Text id="filtersNumberText" weight="bold" size="caption">
            {count}
          </Text>
        </Box>
      )}
    </Box>
  );
};
